(function(){ function start(){
    var root = document.getElementById("tg-bab");
    if (!root) return;
    function on(id, ev, fn) {
      var el = root.querySelector("#"+id);
      if (el) el.addEventListener(ev, fn);
    }

const LIMITS_IN = { w:[0.787, 3.15], t:[0.039, 0.248], lFlatStock:[4, 43], lMto:[19.685, 43], lRound:[20, 43], lDamacore:[12, 24] };
    const MTO_MIN_LEN = 19.685;
    const FLAT_COST_IN3 = 662.41 / (1.5 * 0.125 * 43); // Hugin DS93X flat
    const DC18N_COST_IN3 = 676.61 / (2.5 * 0.156 * 12); // DC18N Odins Eye
    const DC21R_COST_IN3 = 639.27 / (2.5 * 0.156 * 12); // DC21R Baldur 12"
    
    const DC21R_QUOTES = {
      "baldur|2.5|0.156":639.27,"baldur|2.5|0.138":561.90,"baldur|2.5|0.125":508.97,"baldur|2.5|0.118":480.47,
      "baldur|2.0|0.156":511.42,"baldur|2.0|0.138":449.52,"baldur|2.0|0.125":407.18,"baldur|2.0|0.118":384.38,
      "baldur|1.5|0.156":383.56,"baldur|1.5|0.138":337.14,"baldur|1.5|0.125":305.39,"baldur|1.5|0.118":288.28,
      "grosserosen|2.5|0.156":608.95,"grosserosen|2.0|0.156":487.16,"grosserosen|1.5|0.156":365.37,
      "hakkapella|2.5|0.156":608.95,"hakkapella|2.5|0.138":535.26,"hakkapella|2.5|0.125":484.83,"hakkapella|2.5|0.118":457.68,"hakkapella|2.5|0.100":380.11,
      "hakkapella|2.0|0.156":487.16,"hakkapella|2.0|0.138":428.20,"hakkapella|2.0|0.125":387.86,"hakkapella|2.0|0.118":366.15,"hakkapella|2.0|0.100":304.09,
      "hakkapella|1.5|0.156":365.37,"hakkapella|1.5|0.138":321.15,"hakkapella|1.5|0.125":290.90,"hakkapella|1.5|0.118":274.61,"hakkapella|1.5|0.100":228.07,
      "hugin|2.5|0.156":627.06,"hugin|2.5|0.138":551.18,"hugin|2.5|0.125":499.25,"hugin|2.5|0.118":471.29,"hugin|2.5|0.100":391.41,
      "hugin|2.0|0.156":501.65,"hugin|2.0|0.138":440.94,"hugin|2.0|0.125":399.40,"hugin|2.0|0.118":377.04,"hugin|2.0|0.100":313.13,
      "hugin|1.5|0.156":376.23,"hugin|1.5|0.138":330.71,"hugin|1.5|0.125":299.25,"hugin|1.5|0.118":282.77,"hugin|1.5|0.100":234.85,
      "odins-eye|2.5|0.156":608.95,"odins-eye|2.0|0.156":487.16,"odins-eye|1.5|0.156":365.37,
      "rose|2.5|0.156":608.95,"rose|2.5|0.138":535.26,"rose|2.5|0.125":484.83,"rose|2.5|0.118":457.68,"rose|2.5|0.100":380.11,
      "rose|2.0|0.156":487.16,"rose|2.0|0.138":428.20,"rose|2.0|0.125":387.86,"rose|2.0|0.118":366.15,"rose|2.0|0.100":304.09,
      "rose|1.5|0.156":365.37,"rose|1.5|0.138":321.15,"rose|1.5|0.125":290.90,"rose|1.5|0.118":274.61,"rose|1.5|0.100":228.07,
      "thor|2.5|0.156":639.27,"thor|2.5|0.138":561.90,
      "thor|2.0|0.156":511.42,"thor|2.0|0.138":449.52,
      "thor|1.5|0.156":383.56,"thor|1.5|0.138":337.14
    };
    const DC18N_QUOTES = {
      "baldur|2.5|0.248":1122.00,"baldur|2.5|0.190":850.54,"baldur|2.5|0.156":710.29,"baldur|2.5|0.138":624.34,"baldur|2.5|0.125":565.52,"baldur|2.5|0.118":533.86,
      "baldur|2.0|0.156":568.24,"baldur|2.0|0.138":499.47,"baldur|2.0|0.125":452.42,"baldur|2.0|0.118":427.08,
      "baldur|1.5|0.248":673.20,"baldur|1.5|0.190":510.33,"baldur|1.5|0.156":426.18,"baldur|1.5|0.138":374.60,"baldur|1.5|0.125":339.31,"baldur|1.5|0.118":320.31,
      "grosserosen|2.5|0.248":1068.79,"grosserosen|2.5|0.190":810.21,"grosserosen|2.5|0.156":676.61,
      "grosserosen|2.0|0.156":541.29,
      "grosserosen|1.5|0.248":641.27,"grosserosen|1.5|0.190":486.13,"grosserosen|1.5|0.156":405.97,
      "hakkapella|2.5|0.248":1068.79,"hakkapella|2.5|0.190":810.21,"hakkapella|2.5|0.156":676.61,"hakkapella|2.5|0.138":594.73,"hakkapella|2.5|0.125":538.71,"hakkapella|2.5|0.118":508.54,"hakkapella|2.5|0.100":422.34,
      "hakkapella|2.0|0.156":541.29,"hakkapella|2.0|0.138":475.78,"hakkapella|2.0|0.125":430.96,"hakkapella|2.0|0.118":406.83,"hakkapella|2.0|0.100":337.87,
      "hakkapella|1.5|0.248":641.27,"hakkapella|1.5|0.190":486.13,"hakkapella|1.5|0.156":405.97,"hakkapella|1.5|0.138":356.84,"hakkapella|1.5|0.125":323.22,"hakkapella|1.5|0.118":305.12,"hakkapella|1.5|0.100":253.41,
      "hugin|2.5|0.190":834.30,"hugin|2.5|0.156":696.73,"hugin|2.5|0.138":612.41,"hugin|2.5|0.125":554.72,"hugin|2.5|0.118":523.66,"hugin|2.5|0.100":434.90,
      "hugin|2.0|0.156":557.39,"hugin|2.0|0.138":489.93,"hugin|2.0|0.125":443.77,"hugin|2.0|0.118":418.92,"hugin|2.0|0.100":347.92,
      "hugin|1.5|0.190":500.58,"hugin|1.5|0.156":418.04,"hugin|1.5|0.138":367.45,"hugin|1.5|0.125":332.84,"hugin|1.5|0.118":314.20,"hugin|1.5|0.100":260.94,
      "odins-eye|2.5|0.248":1068.79,"odins-eye|2.5|0.190":810.21,"odins-eye|2.5|0.156":676.61,
      "odins-eye|2.0|0.156":541.29,
      "odins-eye|1.5|0.248":641.27,"odins-eye|1.5|0.190":486.13,"odins-eye|1.5|0.156":405.97,
      "rose|2.5|0.190":810.21,"rose|2.5|0.156":676.61,"rose|2.5|0.138":594.73,"rose|2.5|0.125":538.71,"rose|2.5|0.118":508.54,"rose|2.5|0.100":422.34,
      "rose|2.0|0.156":541.29,"rose|2.0|0.138":475.78,"rose|2.0|0.125":430.96,"rose|2.0|0.118":406.83,"rose|2.0|0.100":337.87,
      "rose|1.5|0.190":486.13,"rose|1.5|0.156":405.97,"rose|1.5|0.138":356.84,"rose|1.5|0.125":323.22,"rose|1.5|0.118":305.12,"rose|1.5|0.100":253.41,
      "thor|2.5|0.190":850.54,"thor|2.5|0.156":710.29,"thor|2.5|0.138":624.34,
      "thor|2.0|0.156":568.24,"thor|2.0|0.138":499.47,
      "thor|1.5|0.190":510.33,"thor|1.5|0.156":426.18,"thor|1.5|0.138":374.60
    };
    const ROUND_MIN_LEN = 20;
    const ROUND_QUOTES_20 = {
      "bluetongue|2":2036.53,
      "bluetongue|1.772":1598.67,
      "bluetongue|1.5":1145.55,
      "bluetongue|1.3":860.43,
      "bluetongue|0.984":492.97,
      "bluetongue|0.787":315.34,
      "bluetongue|0.63":202.08,
      "concentric|2":2036.53,
      "concentric|1.5":1145.55,
      "concentric|1.3":860.43,
      "concentric|0.984":492.97,
      "concentric|0.787":315.34,
      "dense-twist|2":2667.27,
      "dense-twist|1.772":2093.79,
      "dense-twist|1.5":1500.34,
      "dense-twist|1.3":1126.92,
      "dense-twist|0.984":645.65,
      "dense-twist|0.787":413.01,
      "dense-twist|0.669":298.44,
      "dense-twist|0.433":125.02,
      "heimskringla|2":2667.27,
      "heimskringla|1.772":2093.79,
      "heimskringla|1.5":1500.34,
      "heimskringla|1.3":1126.92,
      "heimskringla|0.984":645.65,
      "heimskringla|0.787":413.01,
      "heimskringla|0.63":264.66,
      "parallel|2":2036.53,
      "parallel|1.772":1598.67,
      "parallel|1.5":1145.55,
      "parallel|1.3":860.43,
      "parallel|0.984":492.97,
      "parallel|0.787":315.34,
      "parallel|0.669":227.87,
      "parallel|0.433":95.46
    };
    const SAGA_SIZES = [
      { d:0.511, l:11.8, cost:135.79 },
      { d:0.630, l:19.7, cost:344.58 },
      { d:0.787, l:19.7, cost:537.72 },
      { d:0.984, l:19.7, cost:840.61 },
      { d:1.063, l:19.7, cost:981.00 },
      { d:1.300, l:19.7, cost:1467.21 },
      { d:1.653, l:11.8, cost:1420.90 }
    ];
    const ROUND_COST_IN3 = 434.46 / (Math.PI * Math.pow(0.63/2, 2) * 43); // Bluetongue Ø0.630 x 43
    const MARKUP = 2.00;
    const TOL = 0.015;

    const DIAMETERS = [2.000, 1.772, 1.500, 1.300, 0.984, 0.787, 0.669, 0.630, 0.433];

    const PATTERNS_FLAT = [
      { name: "Ægir™", key: "aegir", mult: 1.00, info: "Ægir™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/AEGIR-front_high-8008018-1000x400-3_7b8239bd-0c08-465e-a21b-74b484da7617.jpg?v=1762514337" },
      { name: "Baldur™", key: "baldur", mult: 1.00, info: "Baldur™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Baldur_Front-low-1000x400-1_1cf26f76-6648-4337-afeb-cd5e49ad1828.jpg?v=1762511294" },
      { name: "Bifrost™", key: "bifrost", mult: 1.00, info: "Bifrost™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-bifrost_l_5f5726c8-5f38-459b-9ce0-fc32d290938d.png?v=1762515893" },
      { name: "Björkmans Twist™", key: "bjorkmans-twist", mult: 1.00, info: "Björkmans Twist™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-BJORKMANS-TWIST_40473aee-32cd-46f6-bd67-0fcd5afd6e1b.jpg?v=1762515910" },
      { name: "Dense Twist™", key: "dense-twist", mult: 1.00, info: "Dense Twist™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-densetwist_l_b7210263-84ea-4a16-9f1a-f4508d538742.png?v=1762515927" },
      { name: "Draupner™", key: "draupner", mult: 1.00, info: "Draupner™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/AEGIR-front_high-8008018-1000x400-2_7600233e-32c5-4e77-9c8e-aea61f7f0588.jpg?v=1762511380" },
      { name: "Fafnir™", key: "fafnir", mult: 1.00, info: "Fafnir™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/rn-image_picker_lib_temp_9a535842-4ba7-4771-822e-1bde739fe523.jpg?v=1788609283" },
      { name: "Grabak™", key: "grabak", mult: 1.00, info: "Grabak™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/rn-image_picker_lib_temp_8c206643-0f70-4de2-9658-ba2d138df414.jpg?v=1788609437" },
      { name: "Grosserosen™", key: "grosserosen", mult: 1.00, info: "Grosserosen™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-grosserosen_l_d854d7c9-f6c7-4703-ba99-ac527d6c665d.png?v=1762516393" },
      { name: "Gysinge™", key: "gysinge", mult: 1.00, info: "Gysinge™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-gysinge_l_cac771a0-1c9a-42ec-94ea-e2a7ff1172e8.png?v=1762500822" },
      { name: "Hakkapella™", key: "hakkapella", mult: 1.00, info: "Hakkapella™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-hakkapella_l_19f2c18a-c58a-4050-bc77-8fea864fd0ba.png?v=1762503981" },
      { name: "Heimskringla™", key: "heimskringla", mult: 1.00, info: "Heimskringla™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-HEIMSKRINGLA_20b2caa2-8bed-40a5-a629-b9b6f8c81c99.jpg?v=1762511414" },
      { name: "Hugin™", key: "hugin", mult: 1.00, info: "Hugin™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-hugin_l_7c5234a9-fcce-461c-8fd7-36e104f421ae.png?v=1762499820" },
      { name: "Jörmungandr™", key: "jormungandr", mult: 1.00, info: "Jörmungandr™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/jormungandr-flat.webp?v=1784844622" },
      { name: "Ladder™", key: "ladder", mult: 1.00, info: "Ladder™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-ladder_l_202094ac-44c3-4a06-aa21-a327643c4378.png?v=1762511535" },
      { name: "Loki™", key: "loki", mult: 1.00, info: "Loki™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/rn-image_picker_lib_temp_2ad5e1ba-3864-4efe-b6fa-e796057ea680.jpg?v=1788608721" },
      { name: "Munin™", key: "munin", mult: 1.00, info: "Munin™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-munin_l_51bfbcb3-dc15-4e6e-bd82-4dd0a2f7fdca.png?v=1762504173" },
      { name: "Nidhogg™", key: "nidhogg", mult: 1.00, info: "Nidhogg™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/rn-image_picker_lib_temp_3ca7df6c-151e-44d8-ae56-7683d6731489.jpg?v=1788610170" },
      { name: "Odin Heim™", key: "odin-heim", mult: 1.00, info: "Odin Heim™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-odinheim_l_afaa0840-db42-44d1-8209-d696ca6b50a8.png?v=1762514383" },
      { name: "Odins Eye™", key: "odins-eye", mult: 1.00, info: "Odins Eye™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-odinseye_l_7e515989-582d-4ca3-96d1-373615328641.png?v=1762499889" },
      { name: "Rose™", key: "rose", mult: 1.00, info: "Rose™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-rose_l_de0d72e1-5cae-46bb-9be5-2102175b6905.png?v=1762499612" },
      { name: "Sparse Twist™", key: "sparse-twist", mult: 1.00, info: "Sparse Twist™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/SPARSE-TWIST-back_low-8008058-1000x400-1.jpg?v=1762511397" },
      { name: "Super Dense Twist™", key: "super-dense-twist", mult: 1.00, info: "Super Dense Twist™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/rn-image_picker_lib_temp_726896b8-7a3b-4a8d-b03e-913b1295e2b7.jpg?v=1788608947" },
      { name: "Svavner™", key: "svavner", mult: 1.00, info: "Svavner™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/rn-image_picker_lib_temp_4b76c439-c0b1-48ec-a6bb-c2dd45c1d4c1.jpg?v=1788609092" },
      { name: "Thor™", key: "thor", mult: 1.00, info: "Thor™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-thor_l_c2e5571c-4acd-46a3-98a5-36fb09678bf9.png?v=1762516427" },
      { name: "Vinland™", key: "vinland", mult: 1.00, info: "Vinland™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/products-thor_l_c7f89791-1e7c-4338-bb3e-b26e8f9c0739.png?v=1762511466" },
      { name: "Yggdrasil™", key: "yggdrasil", mult: 1.00, info: "Yggdrasil™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/rn-image_picker_lib_temp_afc722b0-5a91-421f-aa9f-868773cbd4b8.jpg?v=1788609766" }
    ];

    
    
    const DC_WIDTHS = [2.5, 2.0, 1.5];
    const PATTERNS_DC = [
      { name: "Baldur™", key: "baldur", mult: 1.00,
        thick: [0.118,0.125,0.138,0.156],
        thickByGrade: { DC21R: [0.118,0.125,0.138,0.156], DC18N: [0.118,0.125,0.138,0.156,0.190,0.248] },
        widthsByGrade: { DC18N: { "0.248":[2.5,1.5], "0.190":[2.5,1.5] } },
        info: "Baldur™ on Damacore®",
        img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Baldur.jpg?v=1789095164",
        imgByGrade: { DC18N: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Baldur.jpg?v=1789095164", DC21R: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC21R_Baldur.jpg?v=1789095165" } },
      { name: "Grosserosen™", key: "grosserosen", mult: 1.00,
        thick: [0.156],
        thickByGrade: { DC21R: [0.156], DC18N: [0.156,0.190,0.248] },
        widthsByGrade: { DC18N: { "0.248":[2.5,1.5], "0.190":[2.5,1.5], "0.156":[2.5,2.0,1.5] } },
        multByGrade: { DC21R: 608.95/639.27 },
        info: "Grosserosen™ on Damacore®",
        img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Grosserosen.jpg?v=1789095164",
        imgByGrade: { DC18N: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Grosserosen.jpg?v=1789095164", DC21R: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC21R_Grosserosen.jpg?v=1789095165" } },
      { name: "Hakkapella™", key: "hakkapella", mult: 1.00,
        thick: [0.100,0.118,0.125,0.138,0.156],
        thickByGrade: { DC21R: [0.100,0.118,0.125,0.138,0.156], DC18N: [0.100,0.118,0.125,0.138,0.156,0.190,0.248] },
        widthsByGrade: { DC18N: { "0.248":[2.5,1.5], "0.190":[2.5,1.5] } },
        multByGrade: { DC21R: 608.95/639.27 },
        info: "Hakkapella™ on Damacore®",
        img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Hakkapella.jpg?v=1789095164",
        imgByGrade: { DC18N: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Hakkapella.jpg?v=1789095164", DC21R: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC21R_Hakkapella.jpg?v=1789095165" } },
      { name: "Hugin™", key: "hugin", mult: 1.00,
        thick: [0.100,0.118,0.125,0.138,0.156],
        thickByGrade: { DC21R: [0.100,0.118,0.125,0.138,0.156], DC18N: [0.100,0.118,0.125,0.138,0.156,0.190] },
        widthsByGrade: { DC18N: { "0.190":[2.5,1.5] } },
        multByGrade: { DC21R: 627.06/639.27 },
        info: "Hugin™ on Damacore®",
        img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Hugin.jpg?v=1789095164",
        imgByGrade: { DC18N: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Hugin.jpg?v=1789095164", DC21R: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC21R_Hugin.jpg?v=1789095165" } },
      { name: "Odins Eye™", key: "odins-eye", mult: 1.00,
        thick: [0.156],
        thickByGrade: { DC21R: [0.156], DC18N: [0.156,0.190,0.248] },
        widthsByGrade: { DC18N: { "0.248":[2.5,1.5], "0.190":[2.5,1.5], "0.156":[2.5,2.0,1.5] } },
        multByGrade: { DC21R: 608.95/639.27 },
        info: "Odins Eye™ on Damacore®",
        img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Odins_Eye.jpg?v=1789095164",
        imgByGrade: { DC18N: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Odins_Eye.jpg?v=1789095164", DC21R: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC21R_Odins_Eye.jpg?v=1789095164" } },
      { name: "Rose™", key: "rose", mult: 1.00,
        thick: [0.100,0.118,0.125,0.138,0.156],
        thickByGrade: { DC21R: [0.100,0.118,0.125,0.138,0.156], DC18N: [0.100,0.118,0.125,0.138,0.156,0.190] },
        widthsByGrade: { DC18N: { "0.190":[2.5,1.5] } },
        multByGrade: { DC21R: 608.95/639.27 },
        info: "Rose™ on Damacore®",
        img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Rose.jpg?v=1789095165",
        imgByGrade: { DC18N: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Rose.jpg?v=1789095165", DC21R: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC21R_Rose.jpg?v=1789095165" } },
      { name: "Thor™", key: "thor", mult: 710.29/676.61,
        thick: [0.138,0.156],
        thickByGrade: { DC21R: [0.138,0.156], DC18N: [0.138,0.156,0.190] },
        widthsByGrade: { DC18N: { "0.190":[2.5,1.5] } },
        multByGrade: { DC21R: 1.00, DC18N: 710.29/676.61 },
        info: "Thor™ on Damacore®",
        img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Thor.jpg?v=1789095164",
        imgByGrade: { DC18N: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC18N_Thor.jpg?v=1789095164", DC21R: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/Damacore_DC21R_Thor.jpg?v=1789095165" } }
    ];

    const PATTERNS_ROUND = [
      { name: "Bluetongue™", key: "bluetongue", mult: 1.00, info: "Bluetongue™ — round bar pattern.", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/bluetongue_roundbar.jpg?v=1789098645" },
      { name: "Dense Twist™", key: "dense-twist", mult: 1.00, info: "Dense Twist™ — round bar.", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/densetwist_roundbar.jpg?v=1789098645" },
      { name: "Heimskringla™", key: "heimskringla", mult: 1.00, info: "Heimskringla™ — round bar.", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/heimskringla_roundbar.jpg?v=1789095087" },
      { name: "Concentric Layers™", key: "concentric", mult: 1.00, info: "Concentric Layers™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/concentric_roundbar.jpg?v=1789098645" },
      { name: "Parallel Layers™", key: "parallel", mult: 1.00, info: "Parallel Layers™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/parallel_roundbar.jpg?v=1789095087" },
      { name: "Saga™", key: "saga", mult: 1.00, info: "Saga™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/saga_roundbar.jpg?v=1789095087" },
      { name: "Fenja™", key: "fenja", mult: 1.00, info: "Fenja™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/fenja_roundbar.jpg?v=1789095087" },
      { name: "Lucia™", key: "lucia", mult: 1.00, info: "Lucia™", img: "https://cdn.shopify.com/s/files/1/0962/1232/0558/files/lucia_roundbar.jpg?v=1789095087" }
    ];

    
    const STOCK = [
      { key: "rose", w: 1.5, t: 0.125, inches: 38, sku: ".125 x 1-1/2 Rose" },
      { key: "rose", w: 2.0, t: 0.125, inches: 12, sku: ".125 x 2 Rose" },
      { key: "hugin", w: 1.5, t: 0.125, inches: 24, sku: ".125 x 1-1/2 Hugin" },
      { key: "ladder", w: 1.5, t: 0.157, inches: 18, sku: "5/32 x 1-1/2 Ladder" },
      { key: "hakkapella", w: 2.0, t: 0.125, inches: 6, sku: ".125 x 2 Hakkapella" }
    ];

    const sel = root.querySelector("#pattern");
    const diaPick = root.querySelector("#diaPick");
    function fillSaga() {
      const s = root.querySelector("#sagaSize");
      if (!s) return;
      const keep = s.value;
      s.innerHTML = "";
      SAGA_SIZES.forEach((sz,i) => {
        const o = document.createElement("option");
        o.value = i;
        o.textContent = "Ø" + sz.d.toFixed(3) + '" × ' + sz.l.toFixed(1) + '"';
        s.appendChild(o);
      });
      if ([...s.options].some(o => o.value === keep)) s.value = keep;
    }
    function fillDiameters() {
      const p = currentPattern();
      const keep = diaPick.value;
      const quoted = [];
      DIAMETERS.forEach(d => {
        if (ROUND_QUOTES_20[p.key + "|" + String(+d)]) quoted.push(d);
      });
      const list = quoted.length ? quoted : DIAMETERS;
      diaPick.innerHTML = "";
      list.forEach(d => {
        const o = document.createElement("option");
        o.value = d;
        o.textContent = "Ø" + d.toFixed(3) + '"';
        diaPick.appendChild(o);
      });
      if ([...diaPick.options].some(o => o.value === keep)) diaPick.value = keep;
    }

    function isPackagedRound() {
      const v = (sel.value || "").toLowerCase();
      const label = (sel.selectedIndex >= 0 && sel.options[sel.selectedIndex]) ? sel.options[sel.selectedIndex].textContent.toLowerCase() : "";
      return /saga|fenja|lucia/.test(v) || /saga|fenja|lucia/.test(label);
    }
    function isDC() {
      const s = root.querySelector("#steel").value;
      return s === "DC18N" || s === "DC21R";
    }
    function patternList() {
      if (isDC()) return PATTERNS_DC;
      return root.querySelector("#format").value === "round" ? PATTERNS_ROUND : PATTERNS_FLAT;
    }
    function fillDcSizes() {
      const p = currentPattern();
      const selSz = root.querySelector("#dcSize");
      const keep = selSz.value;
      selSz.innerHTML = "";
      const grade = root.querySelector("#steel").value;
      const table = grade === "DC21R" ? DC21R_QUOTES : DC18N_QUOTES;
      const rows = [];
      Object.keys(table).forEach(k => {
        const parts = k.split("|");
        if (parts[0] !== p.key) return;
        rows.push({ w: +parts[1], t: +parts[2] });
      });
      rows.sort((a,b) => b.w - a.w || b.t - a.t);
      rows.forEach(r => {
        const o = document.createElement("option");
        o.value = r.w + "x" + r.t;
        o.textContent = r.w.toFixed(1) + '" × ' + r.t.toFixed(3) + '"';
        selSz.appendChild(o);
      });
      if ([...selSz.options].some(o => o.value === keep)) selSz.value = keep;
    }
    function patternSortName(n) {
      return n.replace(/[™®]/g,"").replace(/Æ/g,"Ae").replace(/æ/g,"ae").replace(/Ö/g,"O").replace(/ö/g,"o").replace(/Ä/g,"A").replace(/ä/g,"a").toLowerCase();
    }
    function fillPatterns() {
      const listId = isDC() ? "dc" : (root.querySelector("#format").value === "round" ? "round" : "flat");
      if (sel.getAttribute("data-list") === listId && sel.options.length) {
        if (isRound()) { fillDiameters(); if (isPackagedRound()) fillSaga(); }
        return;
      }
      const keep = sel.value;
      sel.innerHTML = "";
      patternList().slice().sort((a,b) => patternSortName(a.name).localeCompare(patternSortName(b.name))).forEach(p => {
        const o = document.createElement("option");
        o.value = p.key; o.textContent = p.name; sel.appendChild(o);
      });
      sel.setAttribute("data-list", listId);
      if ([...sel.options].some(o => o.value === keep)) sel.value = keep;
      if (isRound()) { fillDiameters(); if (isPackagedRound()) fillSaga(); }
    }
    fillPatterns();

    function toIn(v, unit) { return unit === "mm" ? v / 25.4 : v; }
    function fmtLim(a, b, unit) {
      return unit === "mm"
        ? `Min: ${(a*25.4).toFixed(2)} / Max: ${(b*25.4).toFixed(2)}`
        : `Min: ${a} / Max: ${b}`;
    }
    function inRange(v, [min, max]) { return v >= min - 0.0001 && v <= max + 0.0001; }
    function currentPattern() {
      const list = patternList();
      const v = (sel.value || "").toLowerCase();
      return list.find(p => p.key === sel.value)
        || list.find(p => p.key === v)
        || list.find(p => (p.name || "").toLowerCase().indexOf(v) !== -1)
        || list[0];
    }

    function matchStock(key, w, t, needLen, qty) {
      return STOCK.find(s =>
        s.key === key &&
        Math.abs(s.w - w) <= TOL &&
        Math.abs(s.t - t) <= TOL &&
        s.inches >= needLen * qty
      );
    }

    function isRound() { return !isDC() && root.querySelector("#format").value === "round"; }

    function syncFormat() {
      const dc = isDC();
      const r = isRound();
      root.querySelector("#format").disabled = dc;
      if (dc) root.querySelector("#format").value = "flat";
      root.querySelector("#flatFields").style.display = (!dc && !r) ? "block" : "none";
      const saga = r && isPackagedRound();
      root.querySelector("#sagaFields").style.display = saga ? "block" : "none";
      root.querySelector("#lenBlock").style.display = saga ? "none" : "block";
      root.querySelector("#roundFields").style.display = (r && !saga) ? "block" : "none";
      if (saga) fillSaga();
      root.querySelector("#damacoreFields").style.display = dc ? "block" : "none";
      fillPatterns();
      if (dc) fillDcSizes();
      root.querySelector("#dia").value = diaPick.value;
      limitsCopy();
    }

    function limitsCopy() {
      const unit = root.querySelector("#unit").value;
      root.querySelector("#wRange").textContent = fmtLim(...LIMITS_IN.w, unit);
      root.querySelector("#tRange").textContent = fmtLim(...LIMITS_IN.t, unit);
      const llim = isDC() ? LIMITS_IN.lDamacore : (isRound() ? LIMITS_IN.lRound : LIMITS_IN.lMto);
      root.querySelector("#lRange").textContent = fmtLim(...llim, unit);
      ["uW","uT","uL","uD"].forEach(id => {
        const el = root.querySelector("#"+id);
        if (el) el.textContent = unit;
      });
    }

    function setWarn(id, inputId, bad) {
      root.querySelector("#"+id).classList.toggle("show", bad);
      root.querySelector("#"+inputId).classList.toggle("invalid", bad);
    }


    const PRODUCT_HANDLES = ["custom-damasteel-order","custom-damasteel","build-a-bar","build-a-bar-damasteel","damasteel-custom-order","custom-damasteel-bar"];

    function currentBuildProps(sell) {
      const steel = root.querySelector("#steel").value;
      const p = currentPattern();
      const unit = root.querySelector("#unit").value;
      const qty = Math.max(1, +root.querySelector("#qty").value || 1);
      const fmt = isDC() ? "Damacore" : (isRound() ? "Round bar" : "Flat bar");
      let size = "";
      if (isDC()) size = (root.querySelector("#dcSize").value || "").replace("x"," × ") + " × " + root.querySelector("#len").value + " " + unit;
      else if (isRound() && isPackagedRound()) {
        const s = root.querySelector("#sagaSize");
        size = s.options[s.selectedIndex] ? s.options[s.selectedIndex].textContent : "";
      } else if (isRound()) size = "Ø" + diaPick.value + " × " + root.querySelector("#len").value + " " + unit;
      else size = root.querySelector("#width").value + " × " + root.querySelector("#thick").value + " × " + root.querySelector("#len").value + " " + unit;
      const status = (root.querySelector("#statusBox").className.indexOf(" in") !== -1 || root.querySelector("#statusBox").className.indexOf("status in") !== -1) ? "In stock" : "Forged-to-order";
      return {
        "Steel": steel,
        "Pattern": p.name,
        "Format": fmt,
        "Size": size,
        "Pieces": String(qty),
        "Quoted price": "$" + sell.toFixed(2),
        "Status": status
      };
    }


    function fracWidth(w) {
      if (Math.abs(w-1.5)<0.02) return "1-1/2";
      if (Math.abs(w-2.5)<0.02) return "2-1/2";
      if (Math.abs(w-1.25)<0.02) return "1-1/4";
      if (Math.abs(w-0.75)<0.02) return "3/4";
      return String(w).replace(/\.0$/,"");
    }
    function thickLabel(t) {
      var s = t.toFixed(3).replace(/0+$/,"").replace(/\.$/,"");
      if (s.charAt(0) === "0") s = s.slice(1);
      return s;
    }
    function variantFitsSize(v, w, t) {
      var sku = String(v.sku || "").toUpperCase().replace(/\s+/g,"");
      var blob = [v.sku, v.title, v.option1, v.option2, v.option3].join(" ").toLowerCase();
      var tCode = String(Math.round(t * 1000));
      var m = sku.match(/(\d+)x(\d+(?:\.\d+)?)/);
      if (m) {
        var tSku = parseInt(m[1], 10) / 1000;
        var wSku = parseFloat(m[2]);
        if (Math.abs(tSku - t) < 0.003) {
          if (Math.abs(wSku - w) < 0.03) return true;
          if (wSku >= 10 && Math.abs(wSku / 10 - w) < 0.03) return true;
        }
      }
      var tLab = thickLabel(t).toLowerCase();
      var wLab = fracWidth(w).toLowerCase();
      if (blob.indexOf(tLab) !== -1 && (blob.indexOf(wLab) !== -1 || blob.indexOf(String(w)) !== -1)) return true;
      return false;
    }
    async function findStockProduct(p, w, t) {
      var queries = [
        thickLabel(t) + " x " + fracWidth(w) + " " + p.name.replace(/[™®]/g,"") + " Damasteel",
        p.name.replace(/[™®]/g,"") + " Damasteel " + thickLabel(t)
      ];
      var seen = {};
      var pat = p.name.replace(/[™®]/g,"").toLowerCase();
      for (var qn = 0; qn < queries.length; qn++) {
        var sug = await fetch("/search/suggest.json?q=" + encodeURIComponent(queries[qn]) + "&resources[type]=product&resources[limit]=10");
        if (!sug.ok) continue;
        var sj = await sug.json();
        var hits = (((sj.resources||{}).results||{}).products)||[];
        for (var i=0;i<hits.length;i++) {
          var handle = hits[i].handle;
          if (!handle || seen[handle]) continue;
          seen[handle] = 1;
          var title = (hits[i].title||"").toLowerCase();
          if (title.indexOf("damasteel") === -1) continue;
          if (title.indexOf(pat) === -1) continue;
          if (title.indexOf("custom") !== -1) continue;
          var pres = await fetch("/products/" + handle + ".js");
          if (!pres.ok) continue;
          var prod = await pres.json();
          var vars = prod.variants || [];
          for (var j=0;j<vars.length;j++) {
            if (variantFitsSize(vars[j], w, t)) {
              prod._matchVariant = vars[j];
              return prod;
            }
          }
          var titleBlob = (prod.title + " " + (prod.description||"").replace(/<[^>]+>/g," ")).toLowerCase();
          var tLab = thickLabel(t).toLowerCase();
          var wLab = fracWidth(w).toLowerCase();
          if (titleBlob.indexOf(tLab) !== -1 && (titleBlob.indexOf(wLab) !== -1 || titleBlob.indexOf(String(w)) !== -1)) {
            prod._matchVariant = vars[0];
            return prod;
          }
        }
      }
      return null;
    }

    async function addToCart(e) {
      if (e) e.preventDefault();
      const add = root.querySelector("#addBtn");
      if (!add || add.disabled) return;
      const sell = parseFloat((root.querySelector("#priceOut").textContent || "").replace(/[^0-9.]/g,""));
      if (!(sell > 0)) { alert("Select a valid size to see a price first."); return; }
      add.disabled = true;
      const old = add.textContent;
      add.textContent = "ADDING…";
      try {
        const steel = root.querySelector("#steel").value;
        const ptn = currentPattern();
        const unit = root.querySelector("#unit").value;
        const pieces = Math.max(1, +root.querySelector("#qty").value || 1);
        const lIn = toIn(+root.querySelector("#len").value || 0, unit);
        const wIn = toIn(+root.querySelector("#width").value || 0, unit);
        const tIn = toIn(+root.querySelector("#thick").value || 0, unit);
        const useRealSku = !isDC() && !isRound();

        let prod = null;
        let cartQty = pieces;
        let props = currentBuildProps(sell);
        let usedRealSku = false;

        if (useRealSku) {
          prod = await findStockProduct(ptn, wIn, tIn);
          if (prod) {
            usedRealSku = true;
            cartQty = Math.max(1, Math.round(lIn * pieces));
            props["Length (inches)"] = String(cartQty);
            var mv = prod._matchVariant || prod.variants[0];
            props["SKU"] = (mv && mv.sku) || prod.handle;
          }
        }
        if (!prod) {
          for (var i = 0; i < PRODUCT_HANDLES.length; i++) {
            const pres = await fetch("/products/" + PRODUCT_HANDLES[i] + ".js");
            if (pres.ok) { prod = await pres.json(); break; }
          }
        }
        if (!prod) {
          const sug = await fetch("/search/suggest.json?q=" + encodeURIComponent("Custom Damasteel Order") + "&resources[type]=product&resources[limit]=5");
          if (sug.ok) {
            const sj = await sug.json();
            const hits = (((sj.resources||{}).results||{}).products)||[];
            if (hits.length && hits[0].handle) {
              const pres2 = await fetch("/products/" + hits[0].handle + ".js");
              if (pres2.ok) prod = await pres2.json();
            }
          }
        }
        if (!prod) throw new Error("Could not find a matching Damasteel product or Custom Damasteel Order on the Online Store.");
        const v = prod._matchVariant || (prod.variants && prod.variants[0]);
        if (!v) throw new Error("That product has no variant.");
        if (!usedRealSku) {
          const cents = parseInt(v.price, 10);
          if (cents === 100) cartQty = Math.max(1, Math.round(sell));
          else if (cents === 1) cartQty = Math.max(1, Math.round(sell * 100));
        }
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: v.id, quantity: cartQty, properties: props })
        });
        const data = await res.json().catch(function(){ return {}; });
        if (!res.ok) throw new Error(data.description || data.message || "Could not add to cart. On the product, turn on Continue selling when out of stock.");
        window.location.href = "/cart";
      } catch (err) {
        alert(err.message || String(err));
        add.disabled = false;
        add.textContent = old;
      }
    }

    function calc() {
      const unit = root.querySelector("#unit").value;
      const l = toIn(+root.querySelector("#len").value || 0, unit);
      const qty = Math.max(1, +root.querySelector("#qty").value || 1);
      const box = root.querySelector("#statusBox");
      const priceBox = root.querySelector("#priceBox");
      const add = root.querySelector("#addBtn");
      const p = currentPattern();
      root.querySelector("#patternInfo").textContent = p.info;
      const imgEl = root.querySelector("#patternImg");
      const steel = root.querySelector("#steel").value;
      const src = (p.imgByGrade && p.imgByGrade[steel]) || p.img || "";
      if (src) {
        imgEl.style.display = "";
        if (imgEl.getAttribute("src") !== src) imgEl.src = src;
      } else {
        imgEl.removeAttribute("src");
        imgEl.style.display = "none";
      }
      imgEl.alt = p.name + " pattern";
      const local = (src||"").indexOf("damasteel-photos/") === 0;
      const fromShop = (src||"").indexOf("cdn.shopify.com") !== -1;
      let cap = p.name;
      if (src) cap += (local || fromShop ? " · Tru-Grit photo" : " · Damasteel photo");
      else if (root.querySelector("#format").value === "round") cap += " · photo pending label";
      root.querySelector("#patternCap").textContent = cap;

      if (isDC()) {
        fillDcSizes();
        const parts = (root.querySelector("#dcSize").value || "2.5x0.156").split("x");
        const w = +parts[0], t = +parts[1];
        const badL = !inRange(l, LIMITS_IN.lDamacore);
        setWarn("lWarn", "len", badL);
        setWarn("wWarn", "width", false);
        setWarn("tWarn", "thick", false);
        if (badL) {
          priceBox.classList.add("hidden");
          add.disabled = true;
          box.className = "status bad";
          box.innerHTML = "<strong>Size not available</strong>Minimum has not been met or maximum was exceeded";
          return;
        }
        const vol = w * t * l;
        const dcRate = root.querySelector("#steel").value === "DC21R" ? DC21R_COST_IN3 : DC18N_COST_IN3;
        const g = root.querySelector("#steel").value;
        const pMult = (p.multByGrade && p.multByGrade[g]) || p.mult;
        const qKey = p.key + "|" + w + "|" + t;
        const table = g === "DC21R" ? DC21R_QUOTES : (typeof DC18N_QUOTES !== "undefined" ? DC18N_QUOTES : null);
        let cost12 = (table && table[qKey]) ? table[qKey] : (vol/l) * 12 * dcRate * pMult;
        const sell = cost12 * (l/12) * 2.00 * qty;
        priceBox.classList.remove("hidden");
        root.querySelector("#priceOut").textContent = "$" + sell.toFixed(2);
        root.querySelector("#priceSub").textContent = qty + " pc · " + root.querySelector("#steel").value + " · " + w + " × " + t + " × " + l.toFixed(3) + " in · FREE SHIPPING";
        add.disabled = false;
        add.textContent = "ADD TO CART — FORGED-TO-ORDER";
        box.className = "status mto";
        box.innerHTML =
          "<strong>Made to order · Damacore®</strong>" +
          root.querySelector("#steel").value + " " + p.name + " in a factory size. " +
          "Typical lead time <strong>2–4 weeks.</strong> Length 12–24 in. <strong>Free shipping</strong> on all Damacore® orders. Please note that all custom forged-to-order bars are final sale.";
        return;
      }

      if (isRound() && isPackagedRound()) {
        fillSaga();
        const sz = SAGA_SIZES[+root.querySelector("#sagaSize").value] || SAGA_SIZES[0];
        setWarn("lWarn", "len", false);
        const sell = sz.cost * 2.00 * qty;
        priceBox.classList.remove("hidden");
        root.querySelector("#priceOut").textContent = "$" + sell.toFixed(2);
        root.querySelector("#priceSub").textContent = qty + " pc · " + p.name + " Ø" + sz.d.toFixed(3) + " × " + sz.l.toFixed(1) + " in";
        add.disabled = false;
        add.textContent = "ADD TO CART — FORGED-TO-ORDER";
        box.className = "status mto";
        box.innerHTML =
          "<strong>Made to order · packaged round bar</strong>" +
          "Factory diameter and length only. Typical lead time <strong>2–4 weeks.</strong> Please note that all custom forged-to-order bars are final sale.";
        return;
      }

      if (isRound()) {
        const dIn = +diaPick.value;
        root.querySelector("#dia").value = unit === "mm" ? (dIn * 25.4).toFixed(2) : dIn;
        const badL = !inRange(l, LIMITS_IN.lRound);
        setWarn("lWarn", "len", badL);
        setWarn("wWarn", "width", false);
        setWarn("tWarn", "thick", false);
        if (badL) {
          priceBox.classList.add("hidden");
          add.disabled = true;
          box.className = "status bad";
          box.innerHTML = "<strong>Size not available</strong>Minimum has not been met or maximum was exceeded";
          return;
        }
        const qk = p.key + "|" + String(+dIn);
        const cost20 = ROUND_QUOTES_20[qk];
        if (!cost20) {
          priceBox.classList.add("hidden");
          add.disabled = true;
          box.className = "status bad";
          box.innerHTML = "<strong>Size not available</strong>No cost on file for this diameter yet.";
          return;
        }
        const sell = cost20 * (l / 20) * p.mult * 2.00 * qty;
        priceBox.classList.remove("hidden");
        root.querySelector("#priceOut").textContent = "$" + sell.toFixed(2);
        root.querySelector("#priceSub").textContent = qty + " pc · Ø" + dIn.toFixed(3) + " × " + l.toFixed(3) + " in";
        add.disabled = false;
        add.textContent = "ADD TO CART — FORGED-TO-ORDER";
        box.className = "status mto";
        box.innerHTML =
          "<strong>Made to order · round bar</strong>" +
          "We do not stock Damasteel round bar. This will be ordered from Damasteel. " +
          "Typical lead time <strong>2–4 weeks.</strong> Minimum order <strong>20 in</strong>. Please note that all custom forged-to-order bars are final sale.";
        return;
      }

      const w = toIn(+root.querySelector("#width").value || 0, unit);
      const t = toIn(+root.querySelector("#thick").value || 0, unit);
      const badW = !inRange(w, LIMITS_IN.w);
      const badT = !inRange(t, LIMITS_IN.t);
      const stockPreview = matchStock(p.key, w, t, l, qty);
      const badL = stockPreview ? !inRange(l, LIMITS_IN.lFlatStock) : !inRange(l, LIMITS_IN.lMto);
      setWarn("wWarn", "width", badW);
      setWarn("tWarn", "thick", badT);
      setWarn("lWarn", "len", badL);

      if (badW || badT || badL || w <= 0 || t <= 0 || l <= 0) {
        priceBox.classList.add("hidden");
        root.querySelector("#priceOut").textContent = "";
        root.querySelector("#priceSub").textContent = "";
        add.disabled = true;
        box.className = "status bad";
        box.innerHTML = "<strong>Size not available</strong>Minimum has not been met or maximum was exceeded. Adjust width, thickness, or length to see a price.";
        return;
      }

      const stock = matchStock(p.key, w, t, l, qty);
      const vol = w * t * l;
      const sell = vol * FLAT_COST_IN3 * p.mult * MARKUP * qty;

      priceBox.classList.remove("hidden");
      root.querySelector("#priceOut").textContent = "$" + sell.toFixed(2);
      root.querySelector("#priceSub").textContent = qty + " pc · " + w.toFixed(3) + " × " + t.toFixed(3) + " × " + l.toFixed(3) + " in";
      add.disabled = false;

      if (stock) {
        box.className = "status in";
        box.innerHTML =
          "<strong>In stock — not made to order</strong>" +
          "We have " + stock.sku + " on the shelf (" + stock.inches + " in remaining). " +
          "Your " + (l * qty).toFixed(2) + " in will be cut from inventory and ships in <strong>1–3 business days</strong>.";
        add.textContent = "ADD TO CART — IN STOCK";
      } else if (l + 0.0001 < MTO_MIN_LEN) {
        priceBox.classList.add("hidden");
        root.querySelector("#priceOut").textContent = "";
        add.disabled = true;
        box.className = "status bad";
        box.innerHTML =
          "<strong>Not in stock · below mill minimum</strong>" +
          "We don’t have this size on the shelf. Damasteel made-to-order bars require at least " +
          MTO_MIN_LEN + " in length. Increase length or pick a stocked width/thickness.";
      } else {
        box.className = "status mto";
        box.innerHTML =
          "<strong>Made to order</strong>" +
          "This size is not on our shelf. We’ll order it from Damasteel. " +
          "Typical lead time <strong>2–4 weeks.</strong> Please note that all custom forged-to-order bars are final sale.";
        add.textContent = "ADD TO CART — FORGED-TO-ORDER";
      }
    }

    function chgQty(n) {
      const q = root.querySelector("#qty");
      q.value = Math.max(1, (+q.value || 1) + n);
      calc();
    }

    function resetForm() {
      root.querySelector("#steel").value = "DS93X";
      root.querySelector("#format").value = "flat";
      root.querySelector("#unit").value = "in";
      root.querySelector("#width").value = 1.5;
      root.querySelector("#thick").value = 0.125;
      root.querySelector("#len").value = 12;
      root.querySelector("#qty").value = 1;
      diaPick.value = "0.63";
      syncFormat();
      sel.selectedIndex = 0;
      calc();
    }

    root.querySelector("#unit").addEventListener("change", () => {
      const unit = root.querySelector("#unit").value;
      ["width","thick","len"].forEach(id => {
        const el = root.querySelector("#"+id);
        const cur = +el.value;
        el.value = unit === "mm" ? (cur * 25.4).toFixed(3) : (cur / 25.4).toFixed(3);
      });
      limitsCopy(); calc();
    });

    ["width","thick","len","qty"].forEach(id => {
      root.querySelector("#"+id).addEventListener("input", calc);
      root.querySelector("#"+id).addEventListener("change", calc);
    });
    root.querySelector("#pattern").addEventListener("change", () => { syncFormat(); calc(); });
    root.querySelector("#steel").addEventListener("change", () => {
      syncFormat();
      if (isDC()) {
        const unit = root.querySelector("#unit").value;
        const l = toIn(+root.querySelector("#len").value || 0, unit);
        if (l < 12 || l > 24) root.querySelector("#len").value = unit === "mm" ? (12*25.4).toFixed(2) : 12;
      }
      calc();
    });
    root.querySelector("#dcSize").addEventListener("change", calc);
    root.querySelector("#format").addEventListener("change", () => {
      syncFormat();
      if (isRound()) {
        const unit = root.querySelector("#unit").value;
        const l = toIn(+root.querySelector("#len").value || 0, unit);
        if (l < MTO_MIN_LEN) {
          root.querySelector("#len").value = unit === "mm" ? (43*25.4).toFixed(2) : 43;
        }
      }
      calc();
    });
    root.querySelector("#sagaSize").addEventListener("change", calc);
    diaPick.addEventListener("change", calc);

    on("clearBtn","click", function(e){ e.preventDefault(); resetForm(); });
    on("qtyMinus","click", function(e){ e.preventDefault(); chgQty(-1); });
    on("qtyPlus","click", function(e){ e.preventDefault(); chgQty(1); });
    on("addBtn","click", addToCart);
    try { syncFormat(); calc(); }
    catch (err) {
      var cap = root.querySelector("#patternCap");
      if (cap) cap.textContent = "Setup error: " + err.message;
      console.error(err);
    }
 } if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start(); })();
